import React, { Component } from 'react'
import { compose } from 'recompose'

import { meta } from 'helpers/decorators'
import { TasksRegistrationParticipants } from 'containers/pages'

const enhance = compose(
  meta({
    title: 'Registration',
    intlKey: 'pageTitle.registrations',
    dynamicProp: 'organizations.detail.name'
  })
)

class RegistrationAwardUnits extends Component {
  render() {
    return <TasksRegistrationParticipants withAwardUnit />
  }
}

export default enhance(RegistrationAwardUnits)
